import Login from './views/public//login/Login.svelte';
import Homepage from './views/private/home/Homepage.svelte';
import Customer from './views/private/customer/Customer.svelte';
import { isLoggedIn } from './utils/store';
import { get } from 'svelte/store';

function isAuthorized() {
  if (process.browser) {
    return get(isLoggedIn);
  }
}

function isNotAuthorized() {
  return !isAuthorized();
}

const routes = [
  {
    name: 'login',
    component: Login,
    onlyIf: { guard: isNotAuthorized, redirect: '/' },
  },
  {
    name: '/',
    layout: Homepage,
    onlyIf: { guard: isAuthorized, redirect: '/login' },
  },
  {
    name: 'customer',
    layout: Customer,
    onlyIf: { guard: isAuthorized, redirect: '/login' },
    nestedRoutes: [
      {
        name: '/:id',
      },
    ],
  },
];

export { routes };
